<template>
    <Layout>
        <div class="row">
            <div class="alert alert-danger alert-dismissible fade show" role="alert"
                v-if="Object.keys(validation_errors).length !== 0">
                <span :key="index" v-for="(err, index) in validation_errors">
                    {{ err[0] }} <br />
                </span>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <b-card>
                    <PageHeader :title="title" :items="items" style="margin-top: -30px" />
                    <form action="">
                        <div class="form-row">
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="form_no">TNA Form No.</label>
                                <input type="number" v-model="search_data.form_no" v-validate="{ regex: /^[0-9]+$/ }"
                                    id="form_no" name="form_no" class="form-control form-control-sm"
                                    placeholder="Search by form No" />
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="household_number">Household Number</label>
                                <input type="text" v-model="search_data.household_number" id="household_number"
                                    class="form-control form-control-sm" placeholder="Search by HH No" />
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="name">Household Head Name</label>
                                <input type="text" v-model="search_data.name" id="name" name="name"
                                    class="form-control form-control-sm" placeholder="Search by Name" />
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="c_village_id">Village</label>
                                <select v-model="search_data.c_village_id" id="c_village_id" name="c_village_id"
                                    class="form-control form-control-sm">
                                    <option :value="''" selected>Select a village</option>
                                    <option :key="index" :value="village.id" v-for="(village, index) in villages">
                                        {{ village.id }} : {{ village.desc }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-md-6 col-sm-6 col-lg-3 mt-1">
                                <label for="c_mouza_id">Mouza</label>
                                <select v-model="search_data.c_mouza_id" class="form-control form-control-sm"
                                    name="c_mouza_id" id="c_mouza_id">
                                    <option selected :value="''">Select a Mouza</option>
                                    <option v-for="(mouza, index) in mouzas" :key="index" :value="mouza.id">{{
                                        mouza.id
                                    }} : {{ mouza.desc }}</option>
                                </select>
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-3 mt-1">
                                <label for="c_training_trade_id">Training Trade</label>
                                <select v-model="search_data.c_training_trade_id" id="c_training_trade_id"
                                    name="c_training_trade_id" class="form-control form-control-sm">
                                    <option :value="''" selected>Select Training Trade</option>
                                    <option :key="index" v-bind:value="trade.id" v-for="(trade, index) in trades">
                                        {{ trade.id }} : {{ trade.desc }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-3 mt-1">
                                <label for="batch_no">Batch No</label>
                                <select v-model="search_data.batch_no" id="batch_no" name="batch_no"
                                    class="form-control form-control-sm">
                                    <option :value="''" selected>Select Batch no.</option>
                                    <option value="01">01</option>
                                    <option value="02">02</option>
                                    <option value="03">03</option>
                                    <option value="04">04</option>
                                    <option value="05">05</option>
                                    <option value="06">06</option>
                                    <option value="07">07</option>
                                    <option value="08">08</option>
                                    <option value="09">09</option>
                                    <option value="10">10</option>
                                    <option value="11">11</option>
                                    <option value="12">12</option>
                                    <option value="13">13</option>
                                    <option value="14">14</option>
                                    <option value="15">15</option>
                                    <option value="16">16</option>
                                    <option value="17">17</option>
                                    <option value="18">18</option>
                                    <option value="19">19</option>
                                    <option value="20">20</option>
                                    <option value="21">21</option>
                                    <option value="22">22</option>
                                    <option value="23">23</option>
                                    <option value="24">24</option>
                                    <option value="25">25</option>
                                </select>
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-3 mt-1">
                                <label for="bank_id">Select Bank</label>
                                <select v-model="search_data.c_bank_id" id="bank_id" name="bank_id"
                                    class="form-control form-control-sm">
                                    <option :value="''" selected>Select Bank</option>
                                    <option v-for="bank in banks" v-bind:value="bank.id" :key="bank.id">
                                        {{ bank.desc }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <button class="btn btn-success btn-sm mt-2" @click.prevent="search">
                            Search
                        </button>
                    </form>
                </b-card>
                <b-card>
                    <div v-if="trainees.total > 0" class="row mb-2">
                        <div class="col-sm-4">
                            <span class="badge badge-success mr-2">Total Search Data Found: {{ trainees.total }}</span>
                            <b-dropdown variant="default" style=" background-color: #d4d4d4; border-color: #8c8c8c;">
                                <template v-slot:button-content>
                                    <i class="fa fa-cog"></i>
                                </template>
                                <b-dropdown-form style="width: 207px !important; overflow-y: auto">
                                    <span v-for="(checkboxArray, index) in checkboxArrays" :key="index" class="ml-3">
                                        <input type="checkbox" v-model="selected" :value="checkboxArray"
                                            :id="checkboxArray">&nbsp;{{ checkboxArray }} <br>
                                    </span>
                                </b-dropdown-form>
                            </b-dropdown>
                        </div>
                    </div>

                    <div class="table-responsive" style="overflow-x: auto">
                        <table class="table table-centered table-striped">
                            <thead>
                                <tr>
                                    <th>Sl</th>
                                    <th v-if="isVisible('Form No.')">Form No.</th>
                                    <th v-if="isVisible('Household Number')">Household Number</th>
                                    <th v-if="isVisible('Name')">Name</th>
                                    <th v-if="isVisible('NID')">NID(ID Type)</th>
                                    <th v-if="isVisible('Mobile')">Mobile</th>
                                    <th v-if="isVisible('Gender')">Gender</th>
                                    <th v-if="isVisible('Father Name')">Father Name</th>
                                    <th v-if="isVisible('Mother Name')">Mother Name</th>
                                    <th v-if="isVisible('Village')">Village</th>
                                    <th v-if="isVisible('Mouza')">Mouza</th>
                                    <th v-if="isVisible('Rep Name')">Rep. Name</th>
                                    <th v-if="isVisible('Rep Father Name')">Rep. Father/Husband Name</th>
                                    <th v-if="isVisible('Rep Mother Name')">Rep Mother Name</th>
                                    <th v-if="isVisible('Rep Relation')">Rep Relation</th>
                                    <th v-if="isVisible('Rep DOB')">Rep DOB</th>
                                    <th v-if="isVisible('Rep Gender')">Rep Gender</th>
                                    <th v-if="isVisible('Rep NID')">Rep NID</th>
                                    <th v-if="isVisible('Rep Mobile')">Rep Mobile</th>
                                    <th v-if="isVisible('Field Book')">Field Book</th>
                                    <th>Bank Name</th>
                                    <th>Account Type</th>
                                    <th>Account No</th>
                                    <th>Branch</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr :key="index" v-for="(trainee, index) in trainees.data">
                                    <td>{{ trainees.from + index }}</td>
                                    <td v-if="isVisible('Form No.')">{{ trainee.form_no }}</td>
                                    <td v-if="isVisible('Household Number')">{{ trainee.household_number }}</td>
                                    <td v-if="isVisible('Name')">
                                        <router-link :to="{
                                            name: 'traineeView',
                                            params: { trainee_id: trainee.id }
                                        }" tag="a" target="_blank">

                                            <span v-for="image in trainee.files" :key="image.id" class="mr-1">
                                                <span v-if="image.file_tag === '1'">
                                                    <img class="rounded-circle" :src="image.name" alt="" width="30px"
                                                        height="30px" />
                                                </span>
                                            </span>
                                            {{ trainee.name }}
                                        </router-link>
                                    </td>
                                    <td v-if="isVisible('NID')">{{ trainee.nid }}({{ trainee.id_type }})</td>
                                    <td v-if="isVisible('Mobile')">{{ trainee.mobile }}</td>
                                    <td v-if="isVisible('Gender')">{{ trainee.gender.desc }}</td>
                                    <td v-if="isVisible('Father Name')">{{ trainee.father_husband_name }}</td>
                                    <td v-if="isVisible('Mother Name')">{{ trainee.mother_name }}</td>
                                    <td v-if="isVisible('Village')">{{ trainee.village.desc }}</td>
                                    <td v-if="isVisible('Mouza')">{{ trainee.mouza.desc }}</td>
                                    <td v-if="isVisible('Rep Name')">
                                        <span v-for="image in trainee.files" :key="image.id" class="mr-1">
                                            <span v-if="image.file_tag === '2'">
                                                <img class="rounded-circle" :src="image.name" alt="" width="30px"
                                                    height="30px" />
                                            </span>
                                        </span>
                                        {{ trainee.rep_name }}
                                    </td>
                                    <td v-if="isVisible('Rep Father Name')">{{ trainee.rep_father_husband_name }}</td>
                                    <td v-if="isVisible('Rep Mother Name')">{{ trainee.rep_mother_name }}</td>
                                    <td v-if="isVisible('Rep Relation')"><span
                                            v-if="trainee.family_relation !== null">{{
                                                trainee.family_relation.desc
                                            }}</span></td>
                                    <td v-if="isVisible('Rep DOB')">{{ trainee.rep_dob }}</td>
                                    <td v-if="isVisible('Rep Gender')"><span v-if="trainee.rep_gender !== null">{{
                                        trainee.rep_gender.desc
                                    }}</span></td>
                                    <td v-if="isVisible('Rep NID')"><span v-if="trainee.rep_nid !== null">{{
                                        trainee.rep_nid
                                    }}({{ trainee.rep_id_type }})</span></td>
                                    <td v-if="isVisible('Rep Mobile')">{{ trainee.rep_mobile }}</td>
                                    <td v-if="isVisible('Field Book')">{{ trainee.field_book_sl }}</td>
                                    <td>
                                        {{
                                            trainee.trainee_bank
                                                ? trainee.trainee_bank.bank.desc
                                                : "N/A"
                                        }}
                                    </td>
                                    <td>
                                        {{
                                            trainee.trainee_bank.trainee_bank_account_type ? trainee.trainee_bank.trainee_bank_account_type.account_type : ''
                                        }}
                                    </td>
                                    <td>
                                        {{
                                            trainee.trainee_bank
                                                ? trainee.trainee_bank.account_no
                                                : "N/A"
                                        }}
                                    </td>
                                    <td>
                                        {{
                                            trainee.trainee_bank
                                                ? trainee.trainee_bank.branch_name
                                                : "N/A"
                                        }}
                                    </td>
                                    <td>
                                        <a v-if="trainee.trainee_bank"
                                            @click.prevent="showBankModal(trainee.id, trainee.rep_name ? trainee.rep_name : trainee.name, trainee.trainee_bank)"
                                            class="action-icon" href="javascript:void(0);" title="Edit bank account">
                                            <i class="mdi mdi-square-edit-outline editButton"></i>
                                        </a>
                                        <a v-else
                                            @click.prevent="showBankModal(trainee.id, trainee.rep_name ? trainee.rep_name : trainee.name)"
                                            class="action-icon" href="javascript:void(0);" title="Add bank account">
                                            <i class="mdi mdi-plus-box addButton"></i>
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <h5 class="text-center text-secondary" v-if="!flag">
                        No Data Found
                    </h5>
                    <div class="float-right">
                        <pagination :data="trainees" :limit="2" @pagination-change-page="getResults"></pagination>
                    </div>
                </b-card>
                <modal-add-trainee-bank :bank="bank" :account_types="accountTypes" :trainee_id="trainee_id"
                    :trainee_name="trainee_name" @getBankTypes="getBankTypes" @search="search">
                </modal-add-trainee-bank>
            </div>
        </div>
    </Layout>
</template>

<script>
import appConfig from "@src/app.config";
import Layout from "@layouts/main";
import PageHeader from "@components/page-header";
import http from "@state/http";
import ModalAddTraineeBank from "../../modals/TraineeBank.vue";

export default {
    page: {
        title: "Create Trainee",
        meta: [{ name: "description", content: appConfig.description }]
    },
    components: { Layout, PageHeader, ModalAddTraineeBank },
    data() {
        return {
            title: "Search Trainee",
            items: [
                {
                    text: "Dashboard",
                    href: "/"
                },
                {
                    text: "Trainee",
                    active: true
                }
            ],
            trainees: {},
            search_data: {
                form_no: '',
                household_number: '',
                name: '',
                c_village_id: '',
                c_mouza_id: '',
                c_training_trade_id: '',
                batch_no: '',
                c_bank_id: '',
            },
            villages: [],
            mouzas: [],
            trainee_id: "",
            trainee_name: '',
            traineeBank: {},
            btn_edit: false,
            validation_errors: {},
            banks: [],
            trades: [],
            bank: {
                desc: ""
            },
            accountTypes: [],
            flag: false,
            file: "",
            checkboxArrays: ['Form No.', 'Household Number', 'Name', 'NID', 'Mobile', 'Gender', 'Father Name', 'Mother Name', 'Village', 'Mouza', 'Rep Name', 'Rep Father Name', 'Rep Mother Name', 'Rep Relation', 'Rep DOB', 'Rep Gender', 'Rep NID', 'Rep Mobile', 'Field Book'],
            selected: ['Name', 'Father Name', 'Village', 'Rep Name', 'Rep Father Name'],
        };
    },

    mounted() {
        this.getCodes();
        this.getBanks();
        this.getTrainingTrade();
    },
    methods: {
        getCodes() {
            http.get("api/ses/codes").then(response => {
                if (!response.error) {
                    let data = response.data;
                    this.villages = data.villages;
                    this.mouzas = data.mouzas;
                }
            });
        },
        showBankModal(id, trainee_name, bank) {
            this.bank = {};
            this.trainee_id = id;
            this.trainee_name = trainee_name;
            if (bank) {
                this.bank = bank;
                var filteredBank = ''
                this.banks.filter(function (thisBank) {
                    if (thisBank.id == bank.bank.id) {
                        filteredBank = thisBank.account_types;
                    }
                }, bank)
                this.accountTypes = filteredBank
            }
            this.$root.$emit("bv::show::modal", "trainee-bank-modal");
        },
        getBankTypes(bank) {
            var filteredBank = ''
            this.banks.filter(function (thisBank) {
                if (thisBank.id == bank.c_bank_id) {
                    filteredBank = thisBank.account_types;
                }
            }, bank)
            this.accountTypes = filteredBank
            this.bank.bank_account_type_id = null
        },
        resetForm() {
            this.btn_edit = false;
            this.traineeBank = {};
            this.search();
        },
        search() {
            http.post("api/trainees/bank/search", this.search_data).then(response => {
                if (!response.error) {
                    this.flag = true;
                    this.trainees = response.data.trainees;
                }
            });
        },
        getBanks() {
            http.get("api/trainee/bank/getBanks/").then(response => {
                if (!response.error) {
                    this.banks = response.data.banks;
                }
            });
        },
        getTrainingTrade() {
            http.get("api/getTrainingTrade/").then(response => {
                if (!response.error) {
                    let data = response.data;
                    this.trades = data.trades;
                }
            });
        },
        getResults(page = 1) {
            http.post('api/trainees/bank/search?page=' + page, this.search_data)
                .then(response => {
                    this.flag = true;
                    this.trainees = response.data.trainees;
                });
        },
        isVisible(row) {
            const matchedValue = this.checkboxArrays.find(
                v => row === v
            );

            if (!matchedValue) {
                return true;
            }
            return this.selected.includes(matchedValue);
        }
    },
};
</script>
